import { memo, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { CustomSelect } from '../Selects'

interface ISortingProps {
  label: string
  options: string[]
  defaultOption: string
}

const sortMap: Record<string, Record<string, string>> = {
  'Oldest': { sortBy: 'CREATED_AT', order: 'ASC' },
  'Newest': { sortBy: 'CREATED_AT', order: 'DESC' },
  'Most usage': { sortBy: 'STATISTICS', order: 'DESC' },
}

const Sorting: React.FC<ISortingProps> = memo(({ options, defaultOption }) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const handleClick = (_prop: string, option: string) => {
    if (!option) {
      searchParams.delete('sortBy')
      searchParams.delete('order')
      searchParams.delete('p')
      setSearchParams(searchParams)
      return
    }
    if (option === defaultOption) {
      searchParams.delete('sortBy')
      searchParams.delete('order')
      searchParams.delete('p')
      setSearchParams(searchParams)
    } else {
      searchParams.set('sortBy', sortMap[option].sortBy)
      searchParams.set('order', sortMap[option].order)
      searchParams.delete('p')
      setSearchParams(searchParams)
    }
  }

  const sortBy = searchParams.get('sortBy')
  const order = searchParams.get('order')

  const selectedOption = useMemo(() => {
    if (!sortBy || !order) {
      return defaultOption
    }
    const foundOption = Object.keys(sortMap).find(
      key => sortMap[key].sortBy === sortBy && sortMap[key].order === order,
    )
    return foundOption || defaultOption
  }, [sortBy, order])

  return (
    <>
      <CustomSelect
        onSelectChange={handleClick}
        options={[defaultOption, ...options]}
        selectedOption={selectedOption}
        name="sortBy"
      />
      <div className="tc-mv-admin-filter-label">Sort by</div>
    </>
  )
})

export { Sorting }
